import { configureStore } from '@reduxjs/toolkit'
import authReducer from './slices/authSlice'
import testReducer from './slices/testSlice'
import timerReducer, { timerMiddleware } from './slices/timerSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    test: testReducer,
    timer: timerReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }).concat(timerMiddleware),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
